import { BaseService } from '@core/service/base.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

export const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
};

@Injectable({
  providedIn: 'root',
})
export class SourceAllService extends BaseService {
  constructor(http: HttpClient) {
    super(http);
  }

  private url = 'api/sourcing/reference';

  getUrl(): string {
    return this.url;
  }

}
